import { AssetType } from 'interfaces'

export const enum DiscoverTab {
  all = 'ALL',
  stock = AssetType.stock,
  blk = 'BLK',
  etf = AssetType.etf,
  fund = AssetType.fund,
  idxFund = AssetType.idxFund,
}
